/* eslint-disable security/detect-object-injection */
import { DeviceType, QueryParams } from '@bees-web/core/types'
import type { GetServerSidePropsContext } from 'next'

type PageQuery = GetServerSidePropsContext['query']

export default function getSanitizedQuery(
  query: PageQuery,
  device: DeviceType
): QueryParams {
  const sanitized: QueryParams = { device }

  Object.entries(query).forEach(([key, value]) => {
    if (key !== 'country' && key !== 'language') {
      sanitized[key === 'id' ? 'entityId' : key] = Array.isArray(value)
        ? value.join(',')
        : value
    }
  })

  return sanitized
}
